define([
    'santa-components',
    'prop-types',
    'componentsCore',
    'mediaControls/utils/mediaControlsUtils'
], function (santaComponents, PropTypes, componentsCore, mediaControlsUtils) {
    'use strict';

    const getReadableTime = mediaControlsUtils.getReadableTime;

    /**
     * @class components.MediaControlTime
     * @extends {core.skinBasedComp}
     */

    return {
        displayName: 'MediaControlTime',
        mixins: [componentsCore.mixins.skinBasedComp],

        propTypes: {
            style: PropTypes.object,
            playerId: PropTypes.string.isRequired,
            mediaAspect: santaComponents.santaTypesDefinitions.SiteAspects.mediaAspect.isRequired
        },

        getInitialState() {
            return {
                currentTime: 0,
                duration: 0
            };
        },

        componentDidMount() {
            this.props.mediaAspect.registerStateChange(this.props.id, this.props.playerId, this.setState.bind(this));
        },

        componentWillUnmount() {
            this.props.mediaAspect.unregisterStateChange(this.props.id, this.props.playerId);
        },

        getSkinProperties() {
            return {
                '': {
                    style: this.props.style
                },
                played: {
                    children: [getReadableTime(this.state.currentTime)]
                },
                total: {
                    children: [getReadableTime(this.state.duration)]
                }
            };
        }
    };
});
